import { getIdToken } from './api';
import config from '../config';

export async function updateAdminUsers(users) {
  const token = await getIdToken();
  const params = {
    method: 'put',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(users),
  };
  return fetch(`${config.baseUrl}/users`, params);
}

export async function getAdminUsers() {
  const token = await getIdToken();
  const params = {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` },
  };
  const users = await fetch(`${config.baseUrl}/users`, params)
    .then((data) => data.json())
    .catch((err) => {
      console.log('Failed to get users', err);
      return [];
    });

  return users
    .filter((user) => {
      return user.providerData && user.providerData.some((d) => d.providerId === 'password');
    })
    .map((user) => {
      const { email, emailVerified, customClaims, multiFactor } = user;
      return {
        email,
        emailVerified,
        role: customClaims ? customClaims.level : '',
        mfa: multiFactor ? multiFactor.enrolledFactors.map((f) => f.factorId).join(',') : '',
      };
    });
}
